import { type ISessionState } from '@inpart-io/devtools-vue';
import { type GetterTree } from 'vuex';

export const GET_TENANT_USER_CURRENT_KEY = 'getTenantUserCurrentKey';
export const IS_LOGGED_IN = 'isLoggedIn';
export const IS_ALLIANCE = 'isAlliance';
export const IS_BETA = 'isBeta';
export const USE_ADVANCED = 'useAdvanced';
export const USE_CHATBOT = 'useChatbot';
export const USE_CORTELLIS = 'useCortellis';
export const USE_DDM = 'useDDM';
export const USE_DEAL_WORKFLOW = 'useDealWorkflow';
export const IS_CONNECTED_TO_EVENT = 'isConnectedToEvent';
export const USE_EVALUATE = 'useEvaluate';

export enum FEATURE_TOGGLE {
    ALLIANCE = 'padme.alliance',
    BETA = 'padme.beta',
    CORTELLIS = 'padme.integration.cortellis',
    DDM = 'padme.integration.ddm',
    DEAL_WORKFLOW = 'padme.workflow',
    CHATBOT = 'padme.chatbot',
    EVALUATE = 'padme.evaluate.disable',
    EVENT = 'padme.integration.event',
    ADVANCED = 'padme.advanced'
}

export const getters: GetterTree<ISessionState, unknown> = {
    [IS_LOGGED_IN]: (_state): boolean => {
        return (_state.userCurrent ?? null) !== null && (_state.tenantCurrent ?? null) !== null && (_state.userTenantAccess ?? null) !== null;
    },
    [USE_ADVANCED]: (_state): boolean => {
        return _state.tenantCurrent?.tenantLicense?.activatedFeatures?.includes(FEATURE_TOGGLE.ADVANCED) ?? false;
    },
    [IS_ALLIANCE]: (_state): boolean => {
        return _state.tenantCurrent?.tenantLicense?.activatedFeatures?.includes(FEATURE_TOGGLE.ALLIANCE) ?? false;
    },
    [IS_BETA]: (_state): boolean => {
        return _state.tenantCurrent?.tenantLicense?.activatedFeatures?.includes(FEATURE_TOGGLE.BETA) ?? false;
    },
    [USE_CORTELLIS]: (_state): boolean => {
        return _state.tenantCurrent?.tenantLicense?.activatedFeatures?.includes(FEATURE_TOGGLE.CORTELLIS) ?? false;
    },
    [USE_DDM]: (_state): boolean => {
        return _state.tenantCurrent?.tenantLicense?.activatedFeatures?.includes(FEATURE_TOGGLE.DDM) ?? false;
    },
    [USE_DEAL_WORKFLOW]: (_state): boolean => {
        return !(_state.tenantCurrent?.tenantLicense?.activatedFeatures?.includes(FEATURE_TOGGLE.DEAL_WORKFLOW) ?? false);
    },
    [USE_EVALUATE]: (_state): boolean => {
        return !(_state.tenantCurrent?.tenantLicense?.activatedFeatures?.includes(FEATURE_TOGGLE.EVALUATE) ?? false);
    },
    [USE_CHATBOT]: (_state): boolean => {
        return _state.tenantCurrent?.tenantLicense?.activatedFeatures?.includes(FEATURE_TOGGLE.CHATBOT) ?? false;
    },
    [GET_TENANT_USER_CURRENT_KEY]: (_state): string | null => {
        const tenantKey: string = _state.tenantCurrent?.name ?? '';
        const userKey: string = _state.userCurrent?.dobjId?.toString();
        return `${tenantKey}-${userKey}`;
    },
    [IS_CONNECTED_TO_EVENT]: (_state): boolean => {
        return _state.tenantCurrent?.tenantLicense?.activatedFeatures?.includes(FEATURE_TOGGLE.EVENT) ?? false;
    }
};
